import {FC, Fragment} from 'react';

import {CompetitiveAnalysis} from './components/competitiveAnalysis';

const RetailerDashboard: FC = () => {
  return (
    <Fragment>
      <div className="page-header-breadcrumb my-[1.5rem] block items-center justify-between md:flex">
        <div>
          <p className="!mb-0 text-[1.125rem] font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70">
            Welcome back, Json Taylor!
          </p>
          <p className="text-[0.813rem] font-normal text-[#8c9097] dark:text-white/50">
            Track your sales activity, leads and deals here.
          </p>
        </div>
        <div className="btn-list mt-2 md:mt-0">
          <button
            type="button"
            className="ti-btn btn-wave !me-[0.375rem] !ms-0 mb-0 !rounded-[0.35rem] bg-primary !px-[0.86rem] !py-[0.51rem] !text-[0.85rem] !font-medium text-white shadow-none"
          >
            <i className="ri-filter-3-fill inline-block"></i>Filters
          </button>
          <button
            type="button"
            className="ti-btn ti-btn-outline-secondary btn-wave !me-[0.375rem] !ms-0 mb-0 !rounded-[0.35rem] !px-[0.86rem] !py-[0.51rem] !text-[0.85rem] !font-medium shadow-none"
          >
            <i className="ri-upload-cloud-line inline-block"></i>Export
          </button>
        </div>
      </div>

      {/* Competitive Analysis */}
      <div className="mb-6">
        <CompetitiveAnalysis />
      </div>

      <div className="fixed inset-0 z-50 hidden bg-gray-900 bg-opacity-50 opacity-0 transition dark:bg-opacity-80"></div>
    </Fragment>
  );
};

export default RetailerDashboard;
